export default {
    ACTIVE_FILTER_STATES: [
        'New',
        'Used',
        'Private',
        'Company',
        'Ended',
        'Auction',
        'FixedPrice',
        'Blekinge',
        'Dalarna',
        'Gavleborg',
        'Gotland',
        'Halland',
        'Jamtland',
        'Jonkoping',
        'Kalmar',
        'Kronoberg',
        'Norrbotten',
        'Skane',
        'Sodermanland',
        'Stockholm',
        'Uppsala',
        'Varmland',
        'Vasterbotten',
        'Vasternorrland',
        'Vastmanland',
        'VastraGotaland',
        'Orebro',
        'Ostergotland',
        'eu;international',
        'nordic;international',
        'international'
    ],
    MODALS: {
        FILTER_MODAL: 'filterModal',
        CATEGORY_MODAL: 'categoryModal'
    },
    ITEM_LAYOUT: {
        GRID: 'layout-grid',
        LIST: 'layout-list'
    }
};
